import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import CategoryLayout from "@/components/feature/CategoryLayout";
import { categories, posts } from "@/mocks/anime";

const category = categories.find((c) => c.id === "avoid")!;
const list = posts.filter((p) => p.category === "avoid");

export default function Avoid() {
  return (
    <>
      <Navbar />
      <main>
        <CategoryLayout
          category={category}
          posts={list}
          description="烂尾、崩坏、节奏拖沓、设定崩盘……避雷指南把老番新番的雷点一次说清，让每一分钟都花在真正值得的好番上。"
        />
      </main>
      <Footer />
    </>
  );
}